import { FileUpload } from '@mui/icons-material';
import {
  Divider,
} from '@mui/material';
import styled from 'styled-components';

import ProfileIcon from '../ProfileIcon';

const BaseProfileIcon = styled(ProfileIcon)`
`;

const SmallProfileIcon = styled(ProfileIcon)`
&& {
  width: 108px;
  height: 108px;
  font-size: 48px;
}
`;

const EditOverlay = styled.div`
  width: 100%;
  border-radius: 50%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000080;
  color: white;
  &:hover {
    cursor: pointer;
  }
`;

const ModalContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing(3)};
`;

const ModalDivider = styled(Divider)`
  && {
    width: 100%;
    color: ${({ theme }) => (theme.palette.gray.light)};
  }
`;

const UploadImage = styled.div`
  width: 144px;
  height: 144px;
  border-radius: ${({ theme }) => (theme.shape.borderRadius * 6)}px;
  background-color: ${({ theme }) => (theme.palette.backdrop.main)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HiddenInput = styled.input`
  display: none;
`;

const UploadIcon = styled(FileUpload)`
  && {
    color: ${({ theme }) => (theme.palette.gray.main)};
    font-size: 36px;
  }
`;

const ProfileContainer = styled.div`
  position: relative;
  width: fit-content;
`;

export { UploadImage,
  BaseProfileIcon,
  ProfileContainer,
  EditOverlay,
  HiddenInput,
  ModalContainer,
  ModalDivider,
  SmallProfileIcon,
  UploadIcon };
